import api from '../../plugins/api';

// GET /services/getDealerAddresses — точки, куда записывают клиента.
// Ведутся в базе (Scripts/add_service_addresses.sql). Отдаёт все активные:
// фильтра по городу нет, клиент может обслуживаться не там, где покупал.
//
// typeId: 3 — сервис (по умолчанию), 1 — тест-драйв.
// markId — только для тест-драйва: сузить до салонов, где эту марку катают.
// Второй аргумент api.get — уже сами query-параметры: обёртка заворачивает их
// в { params } сама. Передашь { params } — уедет params[typeId]=1, бэкенд
// такого не видит и молча отдаёт список по умолчанию.
const getDealerAddresses = (params) => {
  return api.get('/api/services/getDealerAddresses', params);
};

export default getDealerAddresses;
